module.exports = __webpack_public_path__ + "assets/img/landing-page.29579d48.jpg";